var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionalCriteria(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7C16.4017 7 7 16.4017 7 28C7 39.597 16.4017 49 28 49C39.5983 49 49 39.597 49 28V27.9975C49.0038 16.4055 39.6097 7.00379 28.0164 7C28.0114 7 28.0051 7 28 7ZM38.2953 29.8692H29.8692V38.2927H26.1308V29.8667H17.7047V26.1283H26.1308V17.7022H29.8692V26.1283H38.2953V29.8692Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalCriteria);
export default __webpack_public_path__ + "static/media/additional-criteria.d2d15a3c4dae05f1acc5c0d3a8edba64.svg";
export { ForwardRef as ReactComponent };